import React, { ReactNode } from "react";
import styles from "./Backdrop.module.scss";
import classNames from "classnames";

interface Props {
  isOpen: boolean;
  children?: ReactNode;
}

const Backdrop: React.FC<React.PropsWithChildren<Props & React.HTMLProps<HTMLDivElement>>> = ({
  isOpen,
  children,
  className,
  style,
  ...props
}) => {
  return (
    <div
      className={classNames(
        styles.Container,
        { [styles.Hidden]: !isOpen },
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default Backdrop;
